import script from "./LeaderProjectFormStep6.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectFormStep6.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectFormStep6.vue?vue&type=style&index=0&id=6f898e02&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f898e02"]])

export default __exports__